import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from '../generic.service';
import { ProfileStatusResponse } from '../../models/account/profileStatusResponse';
import { StudentProgressStatsResponse } from '../../models/account/studentProgressStatsResponse';
import { StudentProgressInfoResponse } from '../../models/account/studentProgressInfoResponse';
import { LoginStreakResponse } from '../../models/account/loginStreakResponse';

@Injectable({
  providedIn: 'root'
})
export class StudentProgressService {

  constructor(private genericService: GenericService) { }

  getProfileStatus(studentId: string): Observable<ProfileStatusResponse> {
    return this.genericService.get(`user/profilestatus/${studentId}`);
  }

  getStudentProgressStats(studentId: string): Observable<StudentProgressStatsResponse> {
    return this.genericService.get(`user/student-progress-stats/${studentId}`);
  }

  getStudentProgressInfo(studentId: string): Observable<StudentProgressInfoResponse> {
    return this.genericService.get(`user/student-progress-info/${studentId}`);
  }

  getLoginStreak(studentId: string): Observable<LoginStreakResponse> {
    return this.genericService.get(`user/login-streak/${studentId}`);
  }
}
